
export default function Features() {
  const features = [
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Vores kundeservice er altid klar til at hjælpe dig døgnet rundt.'
    },
    {
      icon: 'ri-medal-line',
      title: 'Erfarne Chauffører',
      description: 'Alle vores chauffører er professionelle og har mange års erfaring.'
    },
    {
      icon: 'ri-price-tag-line',
      title: 'Konkurrencedygtige Priser',
      description: 'Få de bedste priser på markedet uden at gå på kompromis med kvaliteten.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Fleksible Tider',
      description: 'Vi tilpasser os dine behov med fleksible afhentnings- og leveringstider.'
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Fuld Forsikring',
      description: 'Alle leveringer er fuldt forsikrede for din tryghed og sikkerhed.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Pålidelig Levering',
      description: 'Professionel håndtering og sikker transport af dine pakker.'
    }
  ];

  return (
    <section id="fordele" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Hvorfor Vælge Gofragt.dk?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Med 10 års erfaring i kurerbranchen tilbyder vi pålidelige og professionelle leveringsløsninger. 
            Vores mål er at gøre dine leveringer så enkle og sikre som muligt.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Image Section */}
        <div className="relative">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <img 
                src="https://public.readdy.ai/ai/img_res/9b72308b4824597484528b5c84becf65.jpg"
                alt="Gofragt.dk professionelle team og faciliteter"
                className="rounded-2xl shadow-xl object-cover w-full h-80"
              />
            </div>
            <div className="order-1 lg:order-2">
              <div className="bg-teal-50 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  10 Års Erfaring
                </h3>
                <p className="text-gray-700 text-lg leading-relaxed mb-6">
                  Siden 2014 har vi leveret pålidelig kurertjeneste til virksomheder og private kunder i hele Danmark. 
                  Vores erfaring og dedikation sikrer, at dine pakker altid kommer sikkert frem.
                </p>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-xl text-white"></i>
                  </div>
                  <span className="text-lg font-semibold text-gray-900">
                    Professionel faglighed og pålidelig service
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
